import { render } from "./mistake.vue?vue&type=template&id=0cc21385&scoped=true"
import script from "./mistake.vue?vue&type=script&lang=js"
export * from "./mistake.vue?vue&type=script&lang=js"

import "./mistake.vue?vue&type=style&index=0&id=0cc21385&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0cc21385"]])

export default __exports__